export const qualities = [
  { id: 1, name: 'A', alias: 'Featured Idol' },
  { id: 2, name: 'B', alias: 'Idol' },
  { id: 3, name: 'C', alias: 'Event' },
  { id: 4, name: 'D', alias: 'Others' },
];



// WEBPACK FOOTER //
// ./src/utils/quality.ts